<app-reports
  title="Partner Portal Claim Reports"
  [filtersForm]="filtersForm"
  [reportsUrl]="reportsUrl"
  [reportsCountUrl]="reportsCountUrl">

  <ng-template appNewReportOptionsTemplate let-filtersForm="filtersForm">
    <ng-container [formGroup]="filtersForm">

      <app-report-sources-option formControlName="sources" />

      <app-report-date-range-option label="Verification Date" formControlName="verifiedDate" />

    </ng-container>
  </ng-template>

  <ng-template appReportDetailsTemplate let-report="report">

    <app-report-applied-sources-option
      [options]="report.filters" />

    <app-report-applied-date-range-option
      [options]="report.filters"
      name="verifiedDate"
      label="Verification Date" />

  </ng-template>

</app-reports>
